<template>
  <div class="page">
    <div class="page-hedaer line-bar-bottom">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item to="/household/index">住户数据</el-breadcrumb-item>
        <el-breadcrumb-item v-if="householdId" :to="'/household/detail/' + householdId">住户详情</el-breadcrumb-item>
        <el-breadcrumb-item>{{ householdId ? '编辑住户' : '新增住户' }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div v-loading="loading" class="page-body form-page form-error__right">
        <el-form :model="form" ref="form" :rules="rules" label-width="150px">
            <el-form-item label="住户名称：" prop="household_name">
                <el-input v-model="form.household_name" maxlength="10" placeholder="请输入住户名称"></el-input>
            </el-form-item>

            <el-form-item label="联系电话：" prop="household_phone">
                <el-input v-model="form.household_phone" maxlength="11" placeholder="请输入联系电话"></el-input>
            </el-form-item>

            <el-form-item label="所属社区：" prop="community_id">
                <el-select v-model="form.community_id" :disabled="!!householdId" placeholder="请选择所属社区" @change="handleZoneChange">
                    <el-option
                        v-for="item in zoneListData"
                        :key="item.community_id"
                        :label="item.community_name"
                        :value="item.community_id"
                    ></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="省市区：">
                <el-input v-model="zoneRegion" readonly placeholder="请选择所属社区"></el-input>
            </el-form-item>

            <el-form-item label="详细地址：" prop="detailed_address">
                <el-input v-model="form.detailed_address" type="textarea" :rows="3" resize="none" show-word-limit maxlength="30" placeholder="请输入详细地址"></el-input>
            </el-form-item>

            <el-form-item label="设备1的类型：" prop="device_type1">
                <el-select v-model="form.device_type1" :disabled="device1_disabled" placeholder="请选择设备1的类型">
                    <el-option label="门磁" :value="0"></el-option>
                    <el-option label="迷你报警器" :value="1"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="设备1的编号：" prop="device_imei1">
                <el-input v-model="form.device_imei1" maxlength="17" :disabled="device1_disabled" placeholder="请输入设备1的编号"></el-input>
            </el-form-item>

            <el-form-item label="设备2的类型：" prop="device_type2">
                <el-select v-model="form.device_type2" :disabled="device2_disabled" placeholder="请选择设备2的类型">
                    <el-option label="门磁" :value="0"></el-option>
                    <el-option label="迷你报警器" :value="1"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="设备2的编号：" prop="device_imei2">
                <el-input v-model="form.device_imei2" maxlength="17" :disabled="device2_disabled" placeholder="请输入设备2的编号"></el-input>
            </el-form-item>

            <el-form-item label="是否隔离：" prop="isolation_state">
                <el-radio v-model="form.isolation_state" :label="1">隔离</el-radio>
                <el-radio v-model="form.isolation_state" :label="0">不隔离</el-radio>
            </el-form-item>

            <el-form-item prop="second_linkman">
                <template slot="label">联系人<span class="el-form-item__labelsup">（选填）</span>：</template>

                <el-input v-model="form.second_linkman" maxlength="10" placeholder="请输入联系人"></el-input>
            </el-form-item>

            <el-form-item prop="second_linkman_phone">
                <template slot="label">联系人电话<span class="el-form-item__labelsup">（选填）</span>：</template>

                <el-input v-model="form.second_linkman_phone" maxlength="11" placeholder="请输入联系人电话"></el-input>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" size="medium" :loading="sending" @click="handleFormSubmit">保 存</el-button>
                <el-button size="medium" @click="$router.go(-1)">取 消</el-button>
            </el-form-item>
        </el-form>
    </div>
  </div>
</template>

<script>
import { ApiHouseholdAdd, ApiHouseholdEdit, ApiHouseholdDetail } from '@/api/household';
import { ApiZoneNoPageList } from '@/api/zone';

import {
 validatePhone, validatePhone2, validateHouseHoldName, validateAddress, validateLinkman,
} from '@/validate';

const defaultForm = {
  household_name: '', // --住户名称 (必传)
  household_phone: '', // --住户手机号(必传)
  isolation_state: 0, // --隔离状态 0：不隔离，1：隔离(必传)
  device_imei1: null, // --设备1编号
  device_type1: 0, // --设备1类型   0：门磁，1：报警器,下同
  device_imei2: null, // --设备2编号
  device_type2: 1, // --设备2类型
  community_id: '', // --这区ID(必传)
  detailed_address: null, // --详细地址
  second_linkman: null, // --第二联系人姓名
  second_linkman_phone: null, // --第二联系人手机
  // third_linkman: null, // --第三联系人姓名
  // third_linkman_phone: null, // --第三联系人手机
};

export default {
  name: 'householdFormPage',
  data() {
    const validateDeviceImei = (rule, value, callback) => {
      // console.log(value);
      if (value && (value.length < 15 || value.length > 17)) {
        callback(new Error('设备编号的长度15-17位'));
      } else {
        callback();
      }
    };

    return {
      loading: false,
      sending: false,

      householdId: this.$route.params.id,

      zoneRegion: '',
      zoneListData: [],

      device1_disabled: false,
      device2_disabled: false,

      form: Object.assign({}, defaultForm),

      rules: {
        household_name: [{ required: true, validator: validateHouseHoldName, trigger: 'blur' }],
        household_phone: [
          { required: true, trigger: 'blur', message: '联系电话不能为空' },
          { required: true, validator: validatePhone, trigger: 'blur' },
        ],
        community_id: [{ required: true, trigger: 'blur', message: '社区不能为空' }],
        detailed_address: [{ required: true, validator: validateAddress, trigger: 'blur' }],
        device_imei1: [{ required: true, trigger: 'blur', validator: validateDeviceImei }],
        device_imei2: [{ required: true, trigger: 'blur', validator: validateDeviceImei }],
        second_linkman: [{ required: true, validator: validateLinkman, trigger: 'blur' }],
        second_linkman_phone: [{ required: true, validator: validatePhone2, trigger: 'blur' }],
      },
    };
  },
  created() {},
  mounted() {
    this.handleGetZoneList(() => {
      if (this.householdId) {
        this.handleGetDetail();
      } else {
        this.loading = false;
      }
    });
  },
  methods: {
    // 获取详情
    handleGetDetail() {
      ApiHouseholdDetail(this.householdId)
        .then((res) => {
          this.loading = false;

          // 设置设备信息
          if (res.data.list && res.data.list.length) {
            res.data.list.forEach((item, index) => {
              res.data['device_type' + (index + 1)] = item.device_type;
              res.data['device_imei' + (index + 1)] = item.device_imei;

              // 已绑定的设备，不允许修改
              if (index === 0) {
                this.device1_disabled = !!item.device_imei;
              }

              if (index === 1) {
                this.device2_disabled = !!item.device_imei;
              }
            });
          }

          this.form = Object.assign({}, res.data);

          this.handleZoneChange();
        })
        .catch(() => {
          this.loading = false;
        });
    },

    // 调用列表Api
    handleGetZoneList(callback) {      
      if (this.loading) {
        return false;
      }

      this.loading = true;

      ApiZoneNoPageList(this.$store.getters.userId).then((res) => {
        this.zoneListData = res.data;

        typeof (callback) === 'function' && callback();
      }).catch(() => {
        typeof (callback) === 'function' && callback();
      });
    },

    // 切换社区
    handleZoneChange() {
      const tmpList = this.zoneListData.filter(item => item.community_id === this.form.community_id);
      console.log(this.form.community_id);
      console.log(tmpList);
      if (tmpList.length) {
        this.zoneRegion = [(tmpList[0].province || ''), (tmpList[0].city || ''), (tmpList[0].district || ''), (tmpList[0].street || '')].join(' ');
      } else {
        this.zoneRegion = '';
      }
    },

    // 提交
    handleFormSubmit() {
      if (this.sending) {
        return false;
      }

      this.$refs.form.validate((valid) => {
        if (valid) {
          this.sending = true;

          this.form.create_user = this.$store.getters.userId;

          const tmpForm = {};

          // 过滤null
          Object.keys(this.form).forEach((key) => {
              // tmpForm[key] = this.form[key] === null ? '' : this.form[key];
              if (typeof (this.form[key]) !== 'object') {
                tmpForm[key] = this.form[key];
              }
          });

          // 设备编号处理
          tmpForm.device_imei1 = tmpForm.device_imei1 === '' ? null : tmpForm.device_imei1;
          tmpForm.device_imei2 = tmpForm.device_imei2 === '' ? null : tmpForm.device_imei2;

          if (this.householdId) {
            tmpForm.household_id = this.householdId;

            ApiHouseholdEdit(tmpForm).then(() => {
              this.dialogVisiable = false;
              this.sending = false;

              this.$message({
                type: 'success',
                message: '修改成功！',
              });

              this.$router.go(-1);
            }).catch(() => {
              this.sending = false;
            });
          } else {
            ApiHouseholdAdd(tmpForm).then(() => {
              this.dialogVisiable = false;
              this.sending = false;

              this.$message({
                type: 'success',
                message: '新增成功！',
              });

              this.$router.go(-1);
            }).catch(() => {
              this.sending = false;
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
